import { Select } from "antd";
import { FC } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

export interface IFacilitySelector {
  clinicList: IClinic[];
  selectedClinic?: IClinic;
  onFacilityChange: (clinicId: number) => void;
}

export const FacilitySelector: FC<IFacilitySelector> = ({
  clinicList,
  selectedClinic,
  onFacilityChange,
}) => {
  return (
    <Select
      className={classNames(styles.selector)}
      value={selectedClinic?.id}
      onChange={onFacilityChange}
      placeholder="Select facility"
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      optionLabelProp="label"
      options={clinicList.map((clinic) => ({
        value: clinic.id,
        label: clinic.name,
        address: clinic.address,
      }))}
      optionRender={(option) => (
        <div className={styles.facilityOption}>
          <span className={styles.name}>{option.data.label}</span>
        </div>
      )}
      style={{ width: 308 }}
    />
  );
};
